export const EMPLOYEE_EXPORT_XLSX_TIMEOUT = 60 * 1000 * 5; //5 mins
